import { Component } from 'react';
import AMS from '@ui/components/ams';
import { PAGE_SEARCH } from '@lib/constants';
import { pushPageViewEvent } from '@lib/atm';
import { searchPageQuery } from '@queries/pages/search';
import { withServerSideProps } from '@lib/withServerSideProps';
import Page from '@ui/components/ams/Pages/Page';

class SearchPage extends Component {
  componentDidMount() {
    const {
      userSessionData: {
        userData,
      },
      locale,
    } = this.props;

    pushPageViewEvent(
      window,
      userData,
      { locale, sections: [PAGE_SEARCH] },
    );
  }

  render() {
    const {
      globalPageData,
      pageData,
      userSessionData,
      requestData,
      locale,
    } = this.props;

    const {
      allSearch,
      allNavigationSearchBars,
    } = pageData;

    const searchQuery = requestData.urlQueryParams.q ?? '';
    const searchNavBarData = allNavigationSearchBars?.[0] ?? {};
    const searchPageData = allSearch || {};
    const pageTitle = `${searchQuery} - ${searchPageData.pageTitle}`;

    return (
      <Page
        analyticsPageName={PAGE_SEARCH}
        pageName={PAGE_SEARCH}
        pageTitle={pageTitle}
        metaDescription={searchPageData.metaDescription}
        globalPageData={globalPageData}
        requestData={requestData}
        userSessionData={userSessionData}
      >
        <AMS.SearchContent
          locale={locale}
          searchPageData={searchPageData}
          searchNavBarData={searchNavBarData}
          searchQuery={searchQuery}
        />
      </Page>
    );
  }
}

export const getServerSideProps = withServerSideProps({
  pageQuery: searchPageQuery,
});

export default SearchPage;
